var chunkMapping = {
	"0": [
		4633
	],
	"3": [
		4011,
		4565
	],
	"79": [
		5082
	],
	"164": [
		5169
	],
	"165": [
		5170
	],
	"168": [
		5173
	],
	"169": [
		5174
	],
	"170": [
		5175
	],
	"171": [
		5176
	],
	"172": [
		5177
	],
	"173": [
		5178
	],
	"174": [
		5179
	],
	"175": [
		5180
	],
	"176": [
		5181
	],
	"177": [
		5182
	],
	"178": [
		5183
	],
	"179": [
		5184
	],
	"180": [
		5185
	],
	"181": [
		5186
	],
	"182": [
		5187
	],
	"183": [
		5188
	],
	"184": [
		5189
	],
	"185": [
		5190
	],
	"186": [
		5191
	],
	"187": [
		5192
	],
	"188": [
		5193
	]
};
var idToExternalAndNameMapping = {
	"4011": [
		"default",
		"./nuorder-components",
		3687
	],
	"4565": [
		"default",
		"./helios-components",
		3687
	],
	"4633": [
		"default",
		"./Containers",
		3596
	],
	"5082": [
		"default",
		"./OrderlessInvoices",
		3596
	],
	"5169": [
		"default",
		"./AsyncEventTracker",
		3596
	],
	"5170": [
		"default",
		"./HostWrapper",
		3596
	],
	"5173": [
		"default",
		"./CheckoutV3",
		3596
	],
	"5174": [
		"default",
		"./CheckoutConfirmation",
		3596
	],
	"5175": [
		"default",
		"./ContactCreditCards",
		3596
	],
	"5176": [
		"default",
		"./AuditDialog",
		3596
	],
	"5177": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3596
	],
	"5178": [
		"default",
		"./InvoiceDialog",
		3596
	],
	"5179": [
		"default",
		"./PaymentDueModal",
		3596
	],
	"5180": [
		"default",
		"./PaymentModal",
		3596
	],
	"5181": [
		"default",
		"./Teams",
		3873
	],
	"5182": [
		"default",
		"./PaymentHistory",
		3596
	],
	"5183": [
		"default",
		"./PaymentConfigurations",
		3596
	],
	"5184": [
		"default",
		"./PaymentPreferences",
		3596
	],
	"5185": [
		"default",
		"./ManagePaymentProcessing",
		3596
	],
	"5186": [
		"default",
		"./MobilePaymentsWrapper",
		3596
	],
	"5187": [
		"default",
		"./PayPage",
		3596
	],
	"5188": [
		"default",
		"./Challenge",
		3596
	],
	"5189": [
		"default",
		"./ManagePaymentMethods",
		3596
	],
	"5190": [
		"default",
		"./LightspeedReports",
		3596
	],
	"5191": [
		"default",
		"./ActivateLightspeedPayments",
		3596
	],
	"5192": [
		"default",
		"./MarketingLandingPage",
		3596
	],
	"5193": [
		"default",
		"./ShippingPromotionsListContainer",
		3596
	]
};
var idToRemoteMap = {
	"4011": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3687
		}
	],
	"4565": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3687
		}
	],
	"4633": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5082": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5169": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5170": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5173": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5174": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5175": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5176": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3873
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}